/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  PutApiV1NotificationMobileAppNotificationidMutationRequest,
  PutApiV1NotificationMobileAppNotificationidMutationResponse,
  PutApiV1NotificationMobileAppNotificationidPathParams,
  PutApiV1NotificationMobileAppNotificationid400,
  PutApiV1NotificationMobileAppNotificationid401,
  PutApiV1NotificationMobileAppNotificationid500,
} from "../../types/notificationMobileAppController/PutApiV1NotificationMobileAppNotificationid.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { putApiV1NotificationMobileAppNotificationid } from "../../clients/notificationMobileAppController/putApiV1NotificationMobileAppNotificationid.ts";

export const putApiV1NotificationMobileAppNotificationidMutationKey = () =>
  [{ url: "/api/v1/notification/mobile-app/:notificationId" }] as const;

export type PutApiV1NotificationMobileAppNotificationidMutationKey = ReturnType<
  typeof putApiV1NotificationMobileAppNotificationidMutationKey
>;

export function putApiV1NotificationMobileAppNotificationidMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PutApiV1NotificationMobileAppNotificationidMutationRequest>
  > & { client?: Client } = {},
) {
  const mutationKey = putApiV1NotificationMobileAppNotificationidMutationKey();
  return mutationOptions<
    PutApiV1NotificationMobileAppNotificationidMutationResponse,
    ResponseErrorConfig<
      | PutApiV1NotificationMobileAppNotificationid400
      | PutApiV1NotificationMobileAppNotificationid401
      | PutApiV1NotificationMobileAppNotificationid500
    >,
    {
      notificationId: PutApiV1NotificationMobileAppNotificationidPathParams["notificationId"];
      data?: PutApiV1NotificationMobileAppNotificationidMutationRequest;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ notificationId, data }) => {
      return putApiV1NotificationMobileAppNotificationid(
        notificationId,
        data,
        config,
      );
    },
  });
}

/**
 * @description Permite editar todos os campos de uma notificação (título, mensagem, turmas, status de matrícula, agendamento, URL externa). Aceita somente notificações com status Rascunho (6) ou Agendado (2). Notificações em processamento, concluídas ou canceladas não podem ser editadas. **(Requer Authorization para autenticação)**
 * @summary Edita uma notificação mobile (Requer Authorization para autenticação)
 * {@link /api/v1/notification/mobile-app/:notificationId}
 */
export function usePutApiV1NotificationMobileAppNotificationid<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PutApiV1NotificationMobileAppNotificationidMutationResponse,
      ResponseErrorConfig<
        | PutApiV1NotificationMobileAppNotificationid400
        | PutApiV1NotificationMobileAppNotificationid401
        | PutApiV1NotificationMobileAppNotificationid500
      >,
      {
        notificationId: PutApiV1NotificationMobileAppNotificationidPathParams["notificationId"];
        data?: PutApiV1NotificationMobileAppNotificationidMutationRequest;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PutApiV1NotificationMobileAppNotificationidMutationRequest>
    > & { client?: Client };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    putApiV1NotificationMobileAppNotificationidMutationKey();

  const baseOptions =
    putApiV1NotificationMobileAppNotificationidMutationOptions(
      config,
    ) as UseMutationOptions<
      PutApiV1NotificationMobileAppNotificationidMutationResponse,
      ResponseErrorConfig<
        | PutApiV1NotificationMobileAppNotificationid400
        | PutApiV1NotificationMobileAppNotificationid401
        | PutApiV1NotificationMobileAppNotificationid500
      >,
      {
        notificationId: PutApiV1NotificationMobileAppNotificationidPathParams["notificationId"];
        data?: PutApiV1NotificationMobileAppNotificationidMutationRequest;
      },
      TContext
    >;

  return useMutation<
    PutApiV1NotificationMobileAppNotificationidMutationResponse,
    ResponseErrorConfig<
      | PutApiV1NotificationMobileAppNotificationid400
      | PutApiV1NotificationMobileAppNotificationid401
      | PutApiV1NotificationMobileAppNotificationid500
    >,
    {
      notificationId: PutApiV1NotificationMobileAppNotificationidPathParams["notificationId"];
      data?: PutApiV1NotificationMobileAppNotificationidMutationRequest;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PutApiV1NotificationMobileAppNotificationidMutationResponse,
    ResponseErrorConfig<
      | PutApiV1NotificationMobileAppNotificationid400
      | PutApiV1NotificationMobileAppNotificationid401
      | PutApiV1NotificationMobileAppNotificationid500
    >,
    {
      notificationId: PutApiV1NotificationMobileAppNotificationidPathParams["notificationId"];
      data?: PutApiV1NotificationMobileAppNotificationidMutationRequest;
    },
    TContext
  >;
}
